import { ArrowRight, Palette, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { PLANTILLAS } from "../templates/registry";
import "./plantillas.css";

const destacados = ["boda-editorial", "quince-lumina", "infantil-fiesta", "formal-prisma"];

export const PlantillasShowcase = () => {
  const plantillas = destacados.map((id) => PLANTILLAS.find((item) => item.id === id)).filter(Boolean);

  return (
    <section id="plantillas" data-testid="templates-showcase" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-2xl">
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-indigo-600">Estilos para tu evento</p>
              <h2 className="mt-3 text-3xl font-medium tracking-tight text-slate-900 sm:text-4xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Elegí una invitación que se parezca a vos
              </h2>
              <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-600">
                Diseños pensados para bodas, 15 años, cumpleaños y eventos formales. Todos se personalizan desde el mismo panel.
              </p>
            </div>
            <Link to="/plantillas/" data-testid="templates-showcase-catalog-link" className="inline-flex min-h-11 items-center justify-center gap-2 self-start rounded-full bg-[#4F5BD5] px-5 text-sm font-semibold text-white transition-colors hover:bg-[#3B46BC] lg:self-auto">
              Ver todas las plantillas
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {plantillas.map((plantilla, index) => (
            <Reveal key={plantilla.id} delay={index * 0.08}>
              <article className="template-highlight-card" data-testid={`template-highlight-${plantilla.id}`}>
                <Link to={`/plantillas/?plantilla=${plantilla.id}`} aria-label={`Ver ${plantilla.nombre}`} className="template-highlight-media">
                  <img src={plantilla.miniatura} alt={`Muestra de ${plantilla.nombre}`} loading="lazy" />
                  <span>{plantilla.tipoEtiqueta}</span>
                </Link>
                <div className="template-highlight-copy">
                  <div className="flex items-center gap-2 text-indigo-600"><Palette className="h-4 w-4" /><span className="text-[11px] font-semibold uppercase tracking-wider">{plantilla.paletas.length} paletas</span></div>
                  <h3>{plantilla.nombre}</h3>
                  <p>{plantilla.descripcion}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-8 flex items-center gap-3 border-t border-slate-100 pt-6 text-sm text-slate-500">
            <Sparkles className="h-4 w-4 text-indigo-500" />
            <span>Podés cambiar de plantilla sin perder los datos de tu evento.</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
